"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _classnames = _interopRequireDefault(require("classnames"));
var _InfoDetailSection = _interopRequireDefault(require("../InfoDetailSection/InfoDetailSection"));
var _delayIcon = _interopRequireDefault(require("../../assets/delay-icon.svg"));
var _errorIcon = _interopRequireDefault(require("../../assets/error-icon.svg"));
var _index = require("../../utils/index");
require("./styles.scss");
var RefundNotification = function RefundNotification(_ref) {
  var isDraftSaved = _ref.isDraftSaved,
    isDraftDeleted = _ref.isDraftDeleted,
    hasError = _ref.hasError,
    isAgent = _ref.isAgent,
    dateProcessed = _ref.dateProcessed,
    refundAmount = _ref.refundAmount,
    creditRemaining = _ref.creditRemaining,
    goToDashboard = _ref.goToDashboard,
    isFullRefund = _ref.isFullRefund;
  var getAttributes = function getAttributes() {
    var buttonLabel = 'OK, Close';
    if (hasError) {
      return {
        title: 'Something Went Wrong',
        imageSrc: _errorIcon.default,
        imageAlt: 'icon depicting an error',
        message: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Unfortunately, our system is currently unavailable."), /*#__PURE__*/_react.default.createElement("p", null, "Please come back later and try again."), !isAgent && /*#__PURE__*/_react.default.createElement("p", null, "As always, feel free to contact us at", ' ', /*#__PURE__*/_react.default.createElement("a", {
          href: "mailto:solutions@lendingclub.com",
          className: "refund-notification__notice__text__email"
        }, "solutions@lendingclub.com"), ' ', "or (800) 630-1663.")),
        buttonLabel: 'Continue'
      };
    }
    if (isDraftSaved) {
      return {
        title: 'Saved Refund Request',
        dateLabel: 'Request Date',
        amountLabel: 'Requested Debit from Provider',
        date: _index.dateFormatter.format(new Date(dateProcessed)),
        amount: (0, _index.toDollar)(refundAmount),
        imageSrc: _delayIcon.default,
        imageAlt: 'icon depicting request is in progress',
        message: /*#__PURE__*/_react.default.createElement("p", null, "The refund request has only been saved as a draft and is not being processed at this time."),
        buttonLabel: buttonLabel
      };
    }
    if (isDraftDeleted) {
      return {
        title: 'Deleted Refund Request',
        imageSrc: _delayIcon.default,
        imageAlt: 'icon depicting request is in progress',
        message: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, "Thank you!"), " The refund request has been deleted."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", null, "To initiate a new refund go to the Practice Center dashboard or contact us at", ' ', /*#__PURE__*/_react.default.createElement("a", {
          href: "mailto:solutions@lendingclub.com",
          className: "refund-notification__notice__text__email"
        }, "solutions@lendingclub.com"), ' ', "or (800) 630-1663.")),
        buttonLabel: buttonLabel
      };
    }
    if (isFullRefund) {
      return {
        title: 'Refund Status',
        imageSrc: null,
        imageAlt: '',
        message: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "This account has been refunded in full."), /*#__PURE__*/_react.default.createElement("p", null, "As always, feel free to contact us at", ' ', /*#__PURE__*/_react.default.createElement("a", {
          href: "mailto:solutions@lendingclub.com",
          className: "refund-notification__notice__text__email"
        }, "solutions@lendingclub.com"), ' ', "or (800) 630-1663.")),
        buttonLabel: buttonLabel
      };
    }
    return {
      title: 'Refund Confirmation',
      dateLabel: 'Complete Date',
      amountLabel: 'Debit from Provider',
      date: _index.dateFormatter.format(new Date(dateProcessed)),
      amount: (0, _index.toDollar)(refundAmount),
      imageSrc: _delayIcon.default,
      imageAlt: 'icon depicting request is in progress',
      message: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("b", null, (0, _index.toDollar)(refundAmount)), " will be debited from your Bank Account within 24-48 hours."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", null, "The Borrower should see ", /*#__PURE__*/_react.default.createElement("b", null, (0, _index.toDollar)(creditRemaining)), " reflected on their account within 5 to 10 business days")),
      buttonLabel: buttonLabel
    };
  };
  var _getAttributes = getAttributes(),
    title = _getAttributes.title,
    dateLabel = _getAttributes.dateLabel,
    amountLabel = _getAttributes.amountLabel,
    date = _getAttributes.date,
    amount = _getAttributes.amount,
    imageSrc = _getAttributes.imageSrc,
    imageAlt = _getAttributes.imageAlt,
    message = _getAttributes.message,
    buttonLabel = _getAttributes.buttonLabel;
  var buttonClasses = (0, _classnames.default)('refund-notification__button', {
    'refund-notification__button--error': hasError
  });
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "refund-notification__title",
    "data-test-id": "notification-title"
  }, title), date && amount && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "".concat(dateLabel, ":"),
    detail: date
  }), /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "".concat(amountLabel, ":"),
    detail: amount
  }), /*#__PURE__*/_react.default.createElement("hr", null)), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    className: "refund-notification__notice"
  }, imageSrc && imageAlt && /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: imageSrc,
    className: "refund-notification__notice__icon",
    alt: imageAlt,
    "data-test-id": "notification-icon"
  }))), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: imageSrc && imageAlt ? 10 : 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "refund-notification__notice__text",
    "data-testid": "notification-text"
  }, message))), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: buttonClasses,
    "aria-label": "Go to dashboard",
    onClick: goToDashboard,
    "data-test-id": "notification-button"
  }, buttonLabel)))));
};
RefundNotification.propTypes = {
  isDraftSaved: _propTypes.bool,
  isDraftDeleted: _propTypes.bool,
  hasError: _propTypes.bool,
  isAgent: _propTypes.bool,
  dateProcessed: _propTypes.string,
  refundAmount: _propTypes.string,
  creditRemaining: _propTypes.number,
  isFullRefund: _propTypes.bool,
  goToDashboard: _propTypes.func.isRequired
};
RefundNotification.defaultProps = {
  isDraftSaved: false,
  isDraftDeleted: false,
  hasError: false,
  isAgent: false,
  dateProcessed: null,
  refundAmount: null,
  creditRemaining: null,
  isFullRefund: false
};
var _default = exports.default = RefundNotification;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/RefundNotification/styles.scss');